"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeyByValue = exports.excludeKeys = exports.convertObjectValuesToString = exports.isSafariBrowser = exports.isEdgeBrowser = exports.isIEBrowser = exports.getFormattedTime = exports.deepCompare = exports.convertByteArrayToUrl = exports.getFileType = exports.convertFileToByteArray = exports.saveFile = exports.downloadFromURL = exports.isBase64ImageUrlOrUrl = exports.readFileAsDataUrl = exports.mapFilePath = exports.isNullOrUndefined = exports.isAlphaNumericWithHyphen = exports.convertToAlphaNumericString = exports.combineUrl = exports.formatString = exports.throttle = exports.debounce = exports.isDate = exports.isObject = exports.isFunction = exports.isArray = exports.isString = exports.isNumber = exports.deepMerge = exports.toTitleCasedKeys = exports.toCamelCasedKeys = exports.toTitleCase = exports.toKeyValuePairs = exports.disallowSpacesValidation = exports.isURL = exports.toCamelCase = exports.generateShortId = exports.generateId = exports.renderClasses = void 0;
const deepmerge = require("deepmerge");
const uuid_1 = require("uuid");
const classesSeparator = ' ';
function renderClasses(classes, baseClassName = '') {
    const calculatedClassName = (classes instanceof Array ? classes : Object.keys(classes).filter(key => classes[key])).join(classesSeparator);
    return `${baseClassName} ${calculatedClassName}`.trim();
}
exports.renderClasses = renderClasses;
function generateId() {
    return uuid_1.v1();
}
exports.generateId = generateId;
function generateShortId() {
    return 'xx4xxyxx'.replace(/[xy]/g, function (character) {
        var randomValue = Math.random() * 16 | 0;
        return (character === 'x' ? randomValue : (randomValue & 0x3 | 0x8)).toString(16);
    });
}
exports.generateShortId = generateShortId;
function toCamelCase(value) {
    return value.length > 1 ? `${value[0].toLowerCase()}${value.slice(1)}` : value;
}
exports.toCamelCase = toCamelCase;
const regexToTestUrl = {
    urlWithoutPortNumber: /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/,
    urlWithPortNumber: /^(http[s]?:\/\/){0,1}[a-zA-Z0-9\-]+\:[0-9]/
};
function isURL(url) {
    return !isNullOrUndefined(url)
        && (regexToTestUrl.urlWithoutPortNumber.test(url)
            || regexToTestUrl.urlWithPortNumber.test(url));
}
exports.isURL = isURL;
const regexToSelectSpaces = /^\s+|\s+$/gm;
function disallowSpacesValidation(fieldValue) {
    return (!isNullOrUndefined(fieldValue) && (fieldValue.toString().replace(regexToSelectSpaces, '').length > 1));
}
exports.disallowSpacesValidation = disallowSpacesValidation;
function toKeyValuePairs(obj, keyName = 'Name', valueName = 'Value') {
    return Object.keys(obj).map(key => ({
        [keyName]: key,
        [valueName]: obj[key]
    }));
}
exports.toKeyValuePairs = toKeyValuePairs;
function toTitleCase(value) {
    return value.length > 1 ? `${value[0].toUpperCase()}${value.slice(1)}` : value;
}
exports.toTitleCase = toTitleCase;
function toCamelCasedKeys(obj, deep = false) {
    return Object.keys(obj).reduce((prev, curr) => {
        let currentValue = obj[curr];
        if (deep) {
            if (isArray(currentValue)) {
                currentValue = currentValue.map((c) => toCamelCasedKeys(c, deep));
            }
            else if (isObject(currentValue) && Object.keys(currentValue).length > 0) {
                currentValue = toCamelCasedKeys(currentValue, deep);
            }
        }
        prev[toCamelCase(curr)] = currentValue;
        return prev;
    }, {});
}
exports.toCamelCasedKeys = toCamelCasedKeys;
function toTitleCasedKeys(obj, deep = false) {
    return Object.keys(obj).reduce((prev, curr) => {
        let currentValue = obj[curr];
        if (deep) {
            if (isArray(currentValue)) {
                currentValue = currentValue.map((c) => toTitleCasedKeys(c, deep));
            }
            else if (isObject(currentValue) && Object.keys(currentValue).length > 0) {
                currentValue = toTitleCasedKeys(currentValue, deep);
            }
        }
        prev[toTitleCase(curr)] = currentValue;
        return prev;
    }, {});
}
exports.toTitleCasedKeys = toTitleCasedKeys;
function deepMerge(...objects) {
    return deepmerge.all(objects);
}
exports.deepMerge = deepMerge;
const typeOfNumber = typeof 0;
function isNumber(value) {
    return !isNaN(value) && typeof value === typeOfNumber;
}
exports.isNumber = isNumber;
const typeOfString = typeof '';
function isString(value) {
    return typeof value === typeOfString;
}
exports.isString = isString;
function isArray(value) {
    return value instanceof Array;
}
exports.isArray = isArray;
function isFunction(value) {
    return value instanceof Function;
}
exports.isFunction = isFunction;
function isObject(value) {
    return (value === Object(value) && !isArray(value) && !isFunction(value));
}
exports.isObject = isObject;
function isDate(date) {
    if (!(date instanceof Date)) {
        return false;
    }
    return isNumber((new Date(date)).getDate());
}
exports.isDate = isDate;
function debounce(callback, wait, context = null) {
    let timerHandle;
    const boundCallback = callback.bind(context);
    return ((...executionParams) => {
        clearTimeout(timerHandle);
        timerHandle = setTimeout(boundCallback, wait, ...executionParams);
    });
}
exports.debounce = debounce;
function throttle(callback, wait, context = null) {
    let shouldWait = false;
    return ((...executionParams) => {
        if (shouldWait) {
            return;
        }
        callback.apply(context, executionParams);
        shouldWait = true;
        setTimeout(() => {
            shouldWait = false;
        }, wait);
    });
}
exports.throttle = throttle;
function formatString(stringToFormat, ...args) {
    args.forEach((arg, idx) => {
        var regEx = new RegExp(`\\{${idx}\\}`, 'gm');
        stringToFormat = stringToFormat.replace(regEx, args[idx]);
    });
    return stringToFormat;
}
exports.formatString = formatString;
function combineUrl(...urls) {
    return urls.map((url, index) => {
        let trimmed = url.trim();
        if (index > 0 && trimmed.startsWith('/')) {
            trimmed = trimmed.slice(1) || '';
        }
        if (index !== (urls.length - 1) && trimmed.endsWith('/')) {
            trimmed = trimmed.slice(0, -1);
        }
        return trimmed;
    }).join('/');
}
exports.combineUrl = combineUrl;
const regexToSelectNonAlphaNumeric = /[^a-zA-Z0-9]/g;
function convertToAlphaNumericString(value) {
    return value.toLowerCase().replace(regexToSelectNonAlphaNumeric, '-');
}
exports.convertToAlphaNumericString = convertToAlphaNumericString;
const regexToSelectAlphaNumericWithHyphen = /[^a-zA-Z0-9-]/;
function isAlphaNumericWithHyphen(value) {
    return regexToSelectAlphaNumericWithHyphen.test(value);
}
exports.isAlphaNumericWithHyphen = isAlphaNumericWithHyphen;
function isNullOrUndefined(value) {
    return value === undefined || value === null;
}
exports.isNullOrUndefined = isNullOrUndefined;
const mapFilePath = (path) => combineUrl(process.env.BASE_PATH || '/', path);
exports.mapFilePath = mapFilePath;
function readFileAsDataUrl(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}
exports.readFileAsDataUrl = readFileAsDataUrl;
const regexToTestIfBase64String = /data:image\/([a-zA-Z]*);base64,([^\"]*)/;
function isBase64ImageUrlOrUrl(url) {
    const isUrlValid = isURL(url);
    const isBase = regexToTestIfBase64String.test(url);
    return (isUrlValid || isBase);
}
exports.isBase64ImageUrlOrUrl = isBase64ImageUrlOrUrl;
function generateURL(content, mimeType) {
    return new Promise(resolve => {
        if (typeof content === 'string') {
            try {
                resolve('data:' + mimeType + ';base64,' + window.btoa(content));
            }
            catch (y) {
                resolve('data:' + mimeType + ',' + encodeURIComponent(content));
            }
        }
        else {
            if (window.URL) {
                resolve(window.URL.createObjectURL(content));
                return;
            }
            const reader = new FileReader();
            reader.onload = function (e) {
                resolve(this.result);
            };
            reader.readAsDataURL(content);
        }
    });
}
const beginsWithDataRegex = /^data:/;
const base64MimeTypeRegex = /^data:([\w\/\-\+]+)/;
function downloadFromURLOnSafariBrowser(url, mimeType) {
    if (beginsWithDataRegex.test(url)) {
        url = 'data:' + url.replace(base64MimeTypeRegex, mimeType);
    }
    const downloadWindow = window.open(url);
    if (downloadWindow) {
        return;
    }
    location.href = url;
}
function downloadFromURL(url, fileName, mimeType) {
    if (isSafariBrowser()) { // For Safari browser
        downloadFromURLOnSafariBrowser(url, mimeType);
        return;
    }
    // For other browsers
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.setAttribute('download', fileName);
    // we need not add HTMLElement to browser, we can invoke a dispatchevent to trigger the click - refer https://stackoverflow.com/a/48367757/3632372
    anchor.dispatchEvent(new MouseEvent(`click`, { bubbles: true, cancelable: true, view: window }));
    return;
}
exports.downloadFromURL = downloadFromURL;
function saveFile(content, fileName, mimeType = 'application/octet-stream') {
    if (navigator.msSaveBlob) { // For IE Browser
        return navigator.msSaveBlob(isString(content) ? new Blob([content]) : content, fileName);
    }
    generateURL(content, mimeType).then((url) => downloadFromURL(url, fileName, mimeType));
    return true;
}
exports.saveFile = saveFile;
function convertFileToByteArray(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(Array.from(new Uint8Array(reader.result)));
        };
        reader.onerror = () => {
            reject(null);
        };
        reader.readAsArrayBuffer(file);
    });
}
exports.convertFileToByteArray = convertFileToByteArray;
const fileTypeMap = {
    csv: ['csv'],
    excel: ['xls', 'xlsx'],
    json: ['json'],
    xml: ['xml']
};
function getFileType(extension) {
    const lowercaseExtension = extension.toLowerCase();
    for (let key of Object.keys(fileTypeMap)) {
        if (fileTypeMap[key].indexOf(lowercaseExtension) > -1) {
            return key;
        }
    }
    return '';
}
exports.getFileType = getFileType;
function convertByteArrayToUrl(byteArray) {
    let binaryString = '';
    byteArray.forEach(charCode => binaryString += String.fromCharCode(charCode));
    return `data:image/png;base64,${btoa(binaryString)}`;
}
exports.convertByteArrayToUrl = convertByteArrayToUrl;
function checkProperties(a, b) {
    const keysOfA = Object.getOwnPropertyNames(a);
    const keysOfB = Object.getOwnPropertyNames(b);
    if (keysOfA.length !== keysOfB.length) {
        return false;
    }
    return keysOfA.every(propName => {
        const valueofA = a[propName];
        const valueofB = b[propName];
        if (isObject(valueofA) || isArray(valueofA)) {
            return checkProperties(valueofA, valueofB);
        }
        if (!b.hasOwnProperty(propName) || valueofB !== valueofA) {
            return false;
        }
        return true;
    });
}
function deepCompare(object1, object2, reverseCheck) {
    const flow = checkProperties(object1, object2);
    if (reverseCheck) {
        return flow && checkProperties(object2, object1);
    }
    return flow;
}
exports.deepCompare = deepCompare;
function getFormattedTime(time) {
    for (let key in time) {
        if (time[key] > 0) {
            if (key === 'MilliSeconds') {
                return { key: key, value: 'just now' };
            }
            return { key: key.toLowerCase(), value: time[key] };
        }
    }
    return { key: '', value: '' };
}
exports.getFormattedTime = getFormattedTime;
const regexToTestIfIEBrowser = /Trident.*rv\:11\./;
function isIEBrowser() {
    return window.navigator.userAgent.indexOf('MSIE ') > 0 || regexToTestIfIEBrowser.test(navigator.userAgent);
}
exports.isIEBrowser = isIEBrowser;
const regexToTestIfEdgeBrowser = /Edge\//;
function isEdgeBrowser() {
    return regexToTestIfEdgeBrowser.test(navigator.userAgent);
}
exports.isEdgeBrowser = isEdgeBrowser;
const regexToTestIfSafariBrowser = /(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//;
function isSafariBrowser() {
    return regexToTestIfSafariBrowser.test(navigator.userAgent);
    ;
}
exports.isSafariBrowser = isSafariBrowser;
function convertObjectValuesToString(items) {
    items.forEach((item) => {
        Object.keys(item).forEach((i) => (item[i] !== null) ? item[i] = item[i].toString() : null);
    });
    return items;
}
exports.convertObjectValuesToString = convertObjectValuesToString;
function excludeKeys(object, ...keys) {
    const objectCopy = { ...object };
    keys.forEach(k => (delete objectCopy[k]));
    return objectCopy;
}
exports.excludeKeys = excludeKeys;
function getKeyByValue(obj, value) {
    return Object.keys(obj).find(key => obj[key] === value);
}
exports.getKeyByValue = getKeyByValue;
//# sourceMappingURL=common.js.map